import { format } from "date-fns";

const generateTimeRanges = (selectedDate, startTime, endTime) => {
  const start = new Date(`1/1/1970 ${startTime}`);
  const end = new Date(`1/1/1970 ${endTime}`);

  const now = new Date();
  const isToday =
    new Date(format(new Date(), "yyyy-MM-dd")).getTime() ===
    new Date(format(selectedDate, "yyyy-MM-dd")).getTime();

  const timeRanges = [];
  while (start < end) {
    const startTimeStr = start.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    start.setMinutes(start.getMinutes() + 15);
    const endTimeStr = start.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    if (isToday) {
      const isLessTime =
        new Date(format(selectedDate, "yyyy-MM-dd") + " " + startTimeStr) <=
        now;
      if (isLessTime) {
        continue;
      }
    }
    timeRanges.push(`${startTimeStr}~${endTimeStr}`);
  }
  return timeRanges;
};

export default generateTimeRanges;
